module.exports = __webpack_public_path__ + "static/media/translate.872ed0c4.svg";